import React from "react";
import { useConfig } from "../../../../../../context/config/configContext"; // CHANGE 1: adjust the path to match this file's location

const getLabel = (type) => {
  if (type === 1) return "Feature";
  if (type === 2) return "Improvement";
  if (type === 3) return "Bug Fix";
};

const getClass = (type) => {
  if (type === 1) return "feature";
  if (type === 2) return "improvement";
  if (type === 3) return "bugfix";
};

const ReleaseItemCard = ({ items }) => {
  const { config } = useConfig();
  if (!items || items.length === 0) return null;

  return (
    <>
      {items.map((item) => (
        <div className="release-card" key={item.Id}>

          <span className={`badge ${getClass(item.ItemType)}`}>
            {getLabel(item.ItemType)}
          </span>

          <h4>{item.Title}</h4>
          <p>{item.Description}</p>

          {item.VideoUrl && config.REACT_APP_RELEASE_KEY && (
            <div className="item-video">
              <iframe
                width="100%"
                height="250"
                src={item.VideoUrl + config.REACT_APP_RELEASE_KEY}
                title={item.Title}
                frameBorder="0"
                allowFullScreen
              />
            </div>
          )}

        </div>
      ))}
    </>
  );
};

export default ReleaseItemCard;